import { render, staticRenderFns } from "./ItemsSupplierOrderUpdate.vue?vue&type=template&id=400180dc&"
import script from "./ItemsSupplierOrderUpdate.vue?vue&type=script&lang=js&"
export * from "./ItemsSupplierOrderUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports